import { Box, Grid, Typography } from "@mui/material";
import NavBarLayout from "../components/nav-bar-layout";
import { useStudentActions } from "../hooks/useStudentActions";
import { useEffect, useState } from "react";
import { newStudent, Student } from "../models/student";
import LoadingSkeleton from "../components/loading-skeleton";
import LecturePreviewCard from "./classroom/lectures/preview-card";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../components/snackbar";
import { AssessmentPreviewCard } from "./classroom/assessments/components/preview-card";
import { CollectionPreviewCard } from "./classroom/library/components/preview-card";
import Lecture from "../models/lecture";
import BackdropLoader from "../components/backdrop-loader";

const API_URL = process.env.REACT_APP_API_URL;

export default function Dashboard() {
    const { student, getStudent, dashboard, getDashboard } = useStudentActions();
    
    const [locStudent, setLocStudent] = useState<Student | null>(null);
    const [loading, setLoading] = useState(false);
    const [joining, setJoining] = useState(false);
    
    useEffect(() => {
        const stored = localStorage.getItem("student");

        if (stored) {
            const parsed = JSON.parse(stored);
            setLocStudent(parsed);
        } else {
            const loadStudent = async () => {
                await getStudent();
            };
            loadStudent();
        }
    }, [student]);

    useEffect(() => {
        if (dashboard) return;
        
        const loadDashboard = async () => {
            setLoading(true);
            await getDashboard();
            setLoading(false);
        };

        loadDashboard();
    }, []);


    return (
        <NavBarLayout>
        {joining && <BackdropLoader/>}
            <Box>
                {/* Welcome */}
                {locStudent && (
                    <Typography 
                        variant="subtitle1" 
                        sx={{ 
                            mb: 4, 
                            fontWeight: 600,
                            color: 'text.primary' 
                        }}
                    >
                        Welcome back, {locStudent.name.split(' ')[0]}
                    </Typography>
                )}

                {(loading || !dashboard || !locStudent) && <LoadingSkeleton/>}
                
                {dashboard && (
                    <>
                    {/* Lectures */}
                    <Box sx={{ mb: 5 }}>
                        <Typography 
                            variant="body1" 
                            sx={{ mb: 1, fontWeight: 500, color: 'text.secondary' }}
                        >
                            Recent Lectures
                        </Typography>

                    {dashboard.lectures.length > 0 ? (
                        <Grid container spacing={3}>
                        {dashboard.lectures.map((lecture) => (
                            <Grid key={lecture.id} size={{ xs: 12, md: 5, lg: 4 }}>
                            <LecturePreviewCard 
                                lecture={lecture} 
                                setJoining={setJoining}
                            />
                            </Grid>
                        ))}
                        </Grid>
                    ) : (
                        <Typography variant="body2" sx={{ color: 'text.disabled', fontStyle: 'italic' }}>
                        No recent lectures available.
                        </Typography>
                    )}
                    </Box>

                    {/* Assessments */}
                    <Box sx={{ mb: 5 }}>
                    <Typography 
                        variant="body1" 
                        sx={{ mb: 1, fontWeight: 500, color: 'text.secondary' }}
                    >
                        Recent Assessments
                    </Typography>

                    {dashboard.assessments.length > 0 ? (
                        <Grid container spacing={3}>
                        {dashboard.assessments.map((assessment) => (
                            <Grid key={assessment.id} size={{ xs: 12, md: 5, lg: 4 }}>
                            <AssessmentPreviewCard assessment={assessment} />
                            </Grid>
                        ))}
                        </Grid>
                    ) : (
                        <Typography variant="body2" sx={{ color: 'text.disabled', fontStyle: 'italic' }}>
                        No recent assessments available.
                        </Typography>
                    )}
                    </Box>

                    {/* Collections */}
                    <Box sx={{ mb: 5 }}>
                    <Typography 
                        variant="body1" 
                        sx={{ mb: 1, fontWeight: 500, color: 'text.secondary' }}
                    >
                        Recent Collections
                    </Typography>

                    {dashboard.collections.length > 0 ? (
                        <Grid container spacing={3}>
                        {dashboard.collections.map((collection) => (
                            <Grid key={collection.id} size={{ xs: 12, md: 5, lg: 4 }}>
                            <CollectionPreviewCard collection={collection} />
                            </Grid>
                        ))}
                        </Grid>
                    ) : (
                        <Typography variant="body2" sx={{ color: 'text.disabled', fontStyle: 'italic' }}>
                        No recent collections available.
                        </Typography>
                    )}
                    </Box>
                </>
                )}

            </Box>
        </NavBarLayout>
    );
}